import { render, staticRenderFns } from "./personal-tab.vue?vue&type=template&id=31a9e36d"
import script from "./personal-tab.vue?vue&type=script&lang=js"
export * from "./personal-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports